export default __webpack_public_path__ + "static/media/real-estate.85280372.svg";